<template>
  <div class="column is-3 fondu" :class="{'fonduenter': contents.length}">
    <aside class="menu is-hidden-mobile">
      <p class="menu-label" style="margin-bottom: 0; font-weight: 600;">
        Administration
      </p>
      <p class="is-size-7" style="margin-bottom: 1em; font-weight: 400;">
        Version 1.1.1
      </p>
      <ul class="menu-list">
        <li v-for="item in menu" :key="item.index">
          <a :href="item.path">
            <span class="icon"><i :class="['fa', item.icon]"></i></span> {{ item.name }}
          </a>
          <ul v-if="item.dropdown && contents">
            <li v-for="content in contents" :key="content['.key']" v-if="!content['single'] || !content['data']">
              <a :href="'/admin/content/' + content['.key']">
                {{ content.name }}
              </a>
            </li>
            <li v-for="content in contents" :key="content['.key']" v-if="content['single'] && content['data']">
              <a :href="'/admin/content/' + content['.key'] + '/edit/' + theKeyOf(content)">
                {{ content.name }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </aside>
    <aside class="menu is-hidden-tablet">
      <p class="menu-label" style="margin-bottom: 0; font-weight: 600;">
        Administration
      </p>
      <p class="is-size-7" style="margin-bottom: 1em; font-weight: 400;">
        Version 1.1.1
      </p>
      <p class="navigationMobile">
        <a @click="toggledocunav = !toggledocunav">
          Navigation <i class="fa fa-arrow-down" :class="{'rotate180': toggledocunav}"></i>
        </a>
      </p>
      <ul class="menu-list" v-if="toggledocunav">
        <li v-for="item in menu" :key="item.index">
          <a :href="item.path">
            <span class="icon"><i :class="['fa', item.icon]"></i></span> {{ item.name }}
          </a>
          <ul v-if="item.dropdown && contents">
            <li v-for="content in contents" :key="content['.key']" v-if="!content['single'] || !content['data']">
              <a :href="'/admin/content/' + content['.key']">
                {{ content.name }}
              </a>
            </li>
            <li v-for="content in contents" :key="content['.key']" v-if="content['single'] && content['data']">
              <a :href="'/admin/content/' + content['.key'] + '/edit/' + theKeyOf(content)">
                {{ content.name }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
import { contentsRef } from '@/admin/firebase_config'
import _ from 'lodash'

export default {
  name: 'sidebar',
  firebase: {
    contents: contentsRef
  },
  data () {
    return {
      // this array contains the all the links in the sidebar
      loaded: true,
      toggledocunav: false,
      menu: [
        {
          name: 'Contenus',
          path: '/admin/content',
          icon: 'fa-wrench',
          dropdown: [
            {
              name: 'Gérer les contenus',
              path: '/admin/content',
              icon: 'fa-file-text',
              supports: null
            }
          ]
        },
        {
          name: 'Routes',
          path: '/admin/routing',
          icon: 'fa-random'
        },
        {
          name: 'Média',
          path: '/admin/media',
          icon: 'fa-picture-o'
        },
        {
          name: 'Base de données',
          path: '/admin/database',
          icon: 'fa-database'
        },
        {
          name: 'Paramètres',
          path: '/admin/settings',
          icon: 'fa-gear'
        }
      ]
    }
  },
  methods: {
    theKeyOf (objto) {
      return _.keys(_.toArray(objto)[0])[0]
    }
  }
}

</script>

<style lang="scss">
  .menu-list a{
    font-weight: 400;
    font-size: 1em;
  }
  p.navigationMobile{
    a i{
      transition: 0.5s;
    }
  }
  .rotate180{
    transform: rotate(180deg);
  }
</style>



// WEBPACK FOOTER //
// src/admin/components/layout/Sidebar.vue